import React, { Component, Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Route, Link } from 'react-router-dom';
import OpenInNewIcon from 'material-ui/svg-icons/action/open-in-new';
import config from '../../config';

import MaterialPaper from 'material-ui/Paper';
import Paper from '../../Components/Paper';

import styles from './PublicReportPage.css';

function getRussianForm(number) {
    if (number % 1 !== 0) return 'genitive';

    let tail = number % 100;
    if (tail >= 11 && tail <= 19) {
        return 'plural';
    }

    tail = tail % 10;
    switch (tail) {
        case 1:
            return 'nominal';
        case 2:
        case 3:
        case 4:
            return 'genitive';
        default:
            return 'plural';
    }
}

class PublicReportPage extends Component {
    state = {
        type: null,
    };

    componentDidMount() {
        fetch(`${config.backend}/papers/report/${this.props.match.params.token}`)
            .then(res => res.json())
            .then(data => this.setState(data));
    }

    getPluralForm = (number, idPrefix) => {
        const {
            intl: { locale, formatMessage },
        } = this.props;

        if (locale === 'ru') {
            return `${number} ${formatMessage({ id: idPrefix + getRussianForm(number) })}`;
        }

        if (locale === 'en') {
            if (number === 1) {
                return `${number} ${formatMessage({ id: idPrefix + 'nominal' })}`;
            }

            return `${number} ${formatMessage({ id: idPrefix + 'plural' })}`;
        }
    };

    getSuffixedNumber = number => {
        const {
            intl: { locale },
        } = this.props;

        if (locale === 'ru') {
            return number + '-й';
        }

        if (locale === 'en') {
            const lastDigit = number % 10,
                lastTwoDigits = number % 100;
            if (lastDigit === 1 && lastTwoDigits !== 11) {
                return number + 'st';
            }
            if (lastDigit === 2 && lastTwoDigits !== 12) {
                return number + 'nd';
            }
            if (lastDigit === 3 && lastTwoDigits !== 13) {
                return number + 'rd';
            }

            return number + 'th';
        }
    };

    handlePaperCloseClick = () => {
        const {
            history,
            match: { url },
        } = this.props;

        history.replace(url);
    };

    renderTownName(town) {
        const {
            intl: { locale },
        } = this.props;

        if (locale === 'ru') {
            let str = town.name.ru;
            if (town.name.local && town.name.ru !== town.name.local) {
                str += ` (${town.name.local})`;
            }

            return str;
        } else {
            let str;

            if (town.name.en) {
                str = town.name.en;
                if (town.name.local && town.name.en !== town.name.local) {
                    str += ' (' + town.name.local + ')';
                }
            } else if (town.name.local) {
                str = town.name.local;
            } else {
                str = town.name.ru;
            }

            return str;
        }
    }

    renderHeads(town) {
        if (town.organizingCommitteePresident && town.organizingCommitteePresident === town.juryPresident) {
            return (
                <Fragment>
                    <FormattedMessage id="Report.PresidentOfAll" />: {town.organizingCommitteePresident}
                </Fragment>
            );
        }

        if (town.juryPresident) {
            return (
                <Fragment>
                    <FormattedMessage id="Report.PresidentOfOrg" />: {town.organizingCommitteePresident}
                    <br />
                    <FormattedMessage id="Report.PresidentOfJury" />: {town.juryPresident}
                </Fragment>
            );
        }

        return (
            <Fragment>
                <FormattedMessage id="Report.PresidentOfOrg" />: {town.organizingCommitteePresident}
            </Fragment>
        );
    }

    renderCorrection(town, tournament) {
        let i;

        for (i = 1; i < tournament.gradeSettings.length; i++) {
            if (tournament.gradeSettings[i].multiplier !== tournament.gradeSettings[i - 1].multiplier) {
                break;
            }
        }

        let start = i - 1;

        if (town.gradeSettings && town.gradeSettings.length) {
            for (i = 0; i < town.gradeSettings.length; i++) {
                if (town.gradeSettings[i].russianEquivalent === start) {
                    start = i;
                    break;
                }
            }
        }

        return (
            <div>
                <FormattedMessage id="Report.correction coeffs" />:
                <table className={styles.coeffTable}>
                    <tbody>
                        <tr>
                            <td>
                                <FormattedMessage id="Report.grade" />
                            </td>
                            <td>≤ {start}</td>
                            <td>{start + 1}</td>
                            <td>{start + 2}</td>
                            <td>{start + 3}</td>
                            <td>{start + 4}</td>
                            <td>≥ {start + 5}</td>
                        </tr>
                        <tr>
                            <td>
                                <FormattedMessage id="Report.junior" />
                            </td>
                            <td>2.00</td>
                            <td>1.50</td>
                            <td>1.33</td>
                            <td>1.00</td>
                            <td>&mdash;</td>
                            <td>&mdash;</td>
                        </tr>
                        <tr>
                            <td>
                                <FormattedMessage id="Report.senior" />
                            </td>
                            <td>1.25</td>
                            <td>1.25</td>
                            <td>1.25</td>
                            <td>1.25</td>
                            <td>1.25</td>
                            <td>1.00</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <FormattedMessage id="Report.threshold" values={{ threshold: tournament.threshold.winner.junior }} />
            </div>
        );
    }

    renderParticipant(participant, town, tournament) {
        const {
            intl: { locale },
            match: { url },
        } = this.props;

        return (
            <Fragment>
                <h4>
                    <span>{participant.fullName}</span>
                    <span className={styles.participantData}>
                        {this.getSuffixedNumber(participant.grade)} <FormattedMessage id="Report.grade" />,{' '}
                        {participant.school}
                    </span>
                    {participant.reportToken && (
                        <a
                            href={`${url
                                .split('/')
                                .slice(0, -1)
                                .join('/')}/${participant.reportToken}`}
                            className={styles.openInNew}
                            target="_blank"
                        >
                            <OpenInNewIcon
                                style={{
                                    color: 'inherit',
                                    height: '16px',
                                    width: '16px',
                                    verticalAlign: 'text-bottom',
                                }}
                            />
                        </a>
                    )}
                </h4>
                {participant.papers.map(paper => (
                    <table className={styles.resultsTable}>
                        <tbody>
                            <tr className={styles.problemNames}>
                                <td>
                                    {paper.filename ? (
                                        <Link to={`${url}/papers/${paper._id}`}>
                                            <FormattedMessage id={`Report.round.${paper.round}`} />{' '}
                                            <FormattedMessage id={`Report.level.${paper.level}`} />
                                        </Link>
                                    ) : (
                                        <Fragment>
                                            <FormattedMessage id={`Report.round.${paper.round}`} />{' '}
                                            <FormattedMessage id={`Report.level.${paper.level}`} />
                                        </Fragment>
                                    )}
                                </td>
                                {tournament[paper.round][paper.level].map(problem => (
                                    <td>
                                        {locale === 'ru'
                                            ? problem.name
                                            : problem.name
                                                  .replace(/а/g, 'a')
                                                  .replace(/б/g, 'b')
                                                  .replace(/в/g, 'c')
                                                  .replace(/г/g, 'd')
                                                  .replace(/д/g, 'e')
                                                  .replace(/е/g, 'f')}
                                    </td>
                                ))}
                                <td />
                            </tr>
                            <tr>
                                <td>
                                    <FormattedMessage id="Report.marks" />
                                </td>
                                {paper.marks.map(mark => (
                                    <td>{mark}</td>
                                ))}
                            </tr>
                            <tr>
                                <td>
                                    <FormattedMessage id="Report.points" />
                                </td>
                                {paper.points.map(point => (
                                    <td>{point}</td>
                                ))}
                            </tr>
                            <tr>
                                <td>
                                    <FormattedMessage id="Report.result" />
                                </td>
                                <td colSpan="11">
                                    {!!(paper.result / paper.sum) &&
                                        `${(paper.result / paper.sum).toFixed(2)} × ${this.getPluralForm(
                                            paper.sum,
                                            'Report.point.'
                                        )} = `}
                                    {this.getPluralForm(paper.result, 'Report.point.')}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                ))}
                <div className={styles.participantResult}>
                    <FormattedMessage id="Report.total result" />:{' '}
                    {this.getPluralForm(participant.bestResult, 'Report.point.')}
                    {participant.award === 'diploma' ? (
                        <Fragment>
                            <br />
                            <FormattedMessage id="Report.awarded with diploma" />
                        </Fragment>
                    ) : null}
                </div>
            </Fragment>
        );
    }

    renderTown() {
        const {
            match: { path },
        } = this.props;
        const { town } = this.state;
        const { tournament, participants } = town;

        return (
            <Fragment>
                <MaterialPaper className={styles.paper}>
                    <h1>
                        {this.getSuffixedNumber(tournament.number)} <FormattedMessage id="Report.TofT" />
                    </h1>
                    <h2>{this.renderTownName(town)}</h2>
                    <div className={styles.row}>
                        <div className={styles.col}>{this.renderHeads(town)}</div>
                        <div className={styles.col}>
                            {this.getPluralForm(participants.length, 'Report.participant.')}
                            <br />
                            {this.getPluralForm(
                                participants.reduce((acc, participant) => acc + participant.papers.length, 0),
                                'Report.paper.'
                            )}
                            <br />
                            {this.getPluralForm(
                                participants.filter(participant => participant.award === 'diploma').length,
                                'Report.diploma.'
                            )}
                            <br />
                        </div>
                    </div>
                    <br />
                    {this.renderCorrection(town, tournament)}
                    <br />
                    <ol>
                        {participants.map(participant => (
                            <li>{this.renderParticipant(participant, town, tournament)}</li>
                        ))}
                    </ol>
                </MaterialPaper>
                <Route
                    path={`${path}/papers/:paperId`}
                    render={({
                        match: {
                            params: { paperId },
                        },
                    }) => {
                        const selectedParticipant = participants.find(participant =>
                            participant.papers.find(paper => paper._id === paperId)
                        );
                        const selectedPaper = selectedParticipant.papers.find(paper => paper._id === paperId);

                        return (
                            <Paper
                                {...selectedPaper}
                                onCloseClick={this.handlePaperCloseClick}
                                editable={false}
                                showMarks={true}
                                tournament={tournament}
                            />
                        );
                    }}
                />
            </Fragment>
        );
    }

    renderSingleParticipant() {
        const {
            match: { path },
        } = this.props;
        const { participant } = this.state;
        const { tournament, town } = participant;

        return (
            <Fragment>
                <MaterialPaper className={styles.paper}>
                    <h1>
                        {this.getSuffixedNumber(tournament.number)} <FormattedMessage id="Report.TofT" />
                    </h1>
                    <h2>{this.renderTownName(town)}</h2>
                    {this.renderHeads(town)}
                    <br />
                    <br />
                    {this.renderCorrection(town, tournament)}
                    <br />
                    {this.renderParticipant(participant, town, tournament)}
                </MaterialPaper>
                <Route
                    path={`${path}/papers/:paperId`}
                    render={({
                        match: {
                            params: { paperId },
                        },
                    }) => {
                        const selectedPaper = participant.papers.find(paper => paper._id === paperId);

                        return (
                            <Paper
                                {...selectedPaper}
                                onCloseClick={this.handlePaperCloseClick}
                                editable={false}
                                showMarks={true}
                                tournament={tournament}
                            />
                        );
                    }}
                />
            </Fragment>
        );
    }

    render() {
        if (!this.state.type) {
            return null;
        }

        if (this.state.type === 'town') {
            return this.renderTown();
        }

        if (this.state.type === 'participant') {
            return this.renderSingleParticipant();
        }
    }
}

export default injectIntl(PublicReportPage);



// WEBPACK FOOTER //
// ./src/Pages/PublicReportPage/PublicReportPage.js